import GuestAppointmentInfoPage from "./GuestAppointmentInfoPage";

export default GuestAppointmentInfoPage;

export * from "./GuestAppointmentInfoPage";
